import { AlertTriangle, RefreshCw } from "lucide-react";
import React from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";
import { t } from "@client/lib/dictionary";
import { Button } from "./button";

const DefaultFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => (
  <div
    role="alert"
    className="flex flex-col items-center justify-center gap-3 p-6 m-2 rounded-lg border border-destructive bg-destructive/5 text-center"
  >
    <AlertTriangle className="h-8 w-8 text-destructive" aria-hidden />
    <h2 className="text-lg font-semibold">{t.app.error}</h2>
    <p className="text-sm text-muted-foreground max-w-md break-words">
      {(error as Error | undefined)?.message ?? "Unknown error"}
    </p>
    <Button onClick={resetErrorBoundary} variant="outline">
      <RefreshCw className="h-4 w-4" /> {t.app.retry}
    </Button>
  </div>
);

interface AppErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ComponentType<FallbackProps>;
}

export const AppErrorBoundary: React.FC<AppErrorBoundaryProps> = ({ children, fallback }) => (
  <ErrorBoundary FallbackComponent={fallback ?? DefaultFallback} onReset={() => window.location.reload()}>
    {children}
  </ErrorBoundary>
);
